import { useSession } from "./session";
import { useDoc } from "../core/useDocSelector";
import { coreDocId } from "../core/schema";
import type { DocHandle } from "../sync/docManager";

/** The current workspace's core doc handle (null until restored). */
export function useCoreDoc(): { handle: DocHandle | null; workspaceId: string | null } {
  const workspaceId = useSession((s) => s.workspaceId);
  const handle = useDoc(workspaceId ? coreDocId(workspaceId) : null);
  return { handle, workspaceId };
}
